import React, { useEffect, useState } from "react";
import {
  Grid,
  Typography,
  Paper,
  IconButton,
  Backdrop,
  CircularProgress,
} from "@mui/material";
import TextInput from "../../Components/InputComponents/TextInput";
import SelectInput from "../../Components/InputComponents/SelectInput";
import CommonButton from "../../Components/InputComponents/CommonButton";
import { useNavigate } from "react-router-dom";
import {
  errorNotify,
  infoNotify,
  successNotify,
} from "../../Components/ToastComponent/ToastNotification";
import { axiosAPI } from "../../Components/AxiosComponents/Axios";

const AddRole = () => {
  const navigate = useNavigate();
  const [data, setData] = useState({
    RL_Name: "",
    RL_Status: 1,
  });
  const [errors, setErrors] = useState({});

  // Validate the form fields
  const validateForm = () => {
    const mandatoryFields = [
      {
        field: "RL_Name",
        label: "Role Name",
      },
      {
        field: "RL_Status",
        label: "Role Status",
      },
    ];

    let formErrors = {};
    const emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
    const phoneRegex = /^[0-9]{20}$/; // 20-digit phone validation

    for (let { field, label, type } of mandatoryFields) {
      const value = data[field];

      if (!value) {
        formErrors[field] = `${label} is required.`;
      } else if (type === "email" && !emailRegex.test(value)) {
        formErrors[field] = `Please enter a valid ${label}.`;
      } 
    }

    setErrors(formErrors);

    if (Object.keys(formErrors).length > 0) {
      // Display the errors as toast notifications
      Object.values(formErrors).forEach((error) => {
        errorNotify(error);
      });
      return false;
    }

    return true;
  };

  // Handle form input changes
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setErrors({
      ...errors,
      [name]: "",
    });

    setData({
      ...data,
      [name]: value,
    });
  };

  const [isDisabled, setIsDisabled] = useState(false);
  const [loaderOpen, setLoaderOpen] = useState(false);

  // Handle form submission
  const handleSubmit = (e) => {
    e.preventDefault();
    if (validateForm()) {
      axiosAPI
        ?.post(`/UserRole/add`, data)
        .then((res) => {
          setIsDisabled(false);
          setLoaderOpen(false);

          if (res?.data?.success) {
            successNotify(res?.data?.message);
            navigate(`/Roles`);
          } else {
            infoNotify(res?.data?.message);
          }
        })
        .catch((err) => {
          errorNotify("Something went wrong!");
          setIsDisabled(false);
          setLoaderOpen(false);
        });
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Paper
      sx={{
        maxWidth: `100vw`,
        padding: 2,
        margin: "auto",
        boxShadow: "none",
        overflowX: "auto",
        fontFamily: "Geist, sans-serif",
        minHeight: "100%",
      }}
    >
      {/* Main Heading */}
      <Typography
        variant="h5"
        sx={{
          fontWeight: 700,
          textAlign: "left",
          marginBottom: 3,
          fontFamily: "Geist, sans-serif",
        }}
      >
        Add Role
      </Typography>

      <Grid
        container
        sx={{
          border: "1px solid lightgrey",
          borderRadius: "10px",
          padding: "20px",
        }}
      >
        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Role Name <span style={{ color: "red" }}> * </span>
          </Typography>
          <TextInput
            label="Full Name"
            placeholder="Enter Full Name"
            name="RL_Name"
            value={data.RL_Name}
            onChange={handleInputChange}
            error={!!errors.RL_Name}
          />
        </Grid>

        <Grid item sx={{ padding: "5px" }} xs={12} sm={6} md={6}>
          <Typography
            variant="subtitle1"
            sx={{ fontWeight: 500, fontFamily: "Geist, sans-serif" }}
          >
            Status <span style={{ color: "red" }}> * </span>
          </Typography>
          <SelectInput
            value={data?.RL_Status}
            onChange={handleInputChange}
            options={[
              { value: "1", label: "Active" },
              { value: "0", label: "Inactive" },
            ]}
            name="RL_Status"
            placeholder="Select Status"
            error={!!errors.RL_Status}
          />
        </Grid>
      </Grid>

      {/* Buttons */}
       <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 3 }}>
        <Grid item>
          <CommonButton
           variant="outlined"
            customColor="#B0BEC5"
            onClick={() => {
              navigate(`/Roles`);
            }}
           
          >
            Cancel
          </CommonButton>
        </Grid>
        <Grid item>
          <CommonButton
           onClick={handleSubmit}
            disabled={isDisabled}
            variant="contained"
            customColor="#007BFF"
          
          >
            {isDisabled ? "Saving..." : "Save"}
          </CommonButton>
        </Grid>
      </Grid>
      <Backdrop
        open={loaderOpen}
        sx={{
          zIndex: (theme) => theme.zIndex.drawer + 1,
          color: "#fff",
          backdropFilter: "blur(5px)",
          backgroundColor: "rgba(0, 0, 0, 0.2)",
          flexDirection: "column",
        }}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </Paper>
  );
};

export default AddRole;
